import React, { Suspense } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";

import MainLayout from "./layout/MainLayout";
import AuthLayout from "./layout/AuthLayout";
import LoadingSpinner from "./components/UI/loadingSpinner/LoadingSpinner";
import "./scss/App.scss";
import Login from "./pages/Login";
import SignupBox from "./components/signup/Signup";

const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Customers = React.lazy(() => import("./pages/Customers"));
const NotFound = React.lazy(() => import("./pages/NotFound"));
const Products = React.lazy(() => import("./pages/Products"));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route index element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignupBox />} />

          <Route element={<AuthLayout />}>
            <Route element={<MainLayout />}>
              <Route path="/upload-file" element={<Dashboard />} />
              <Route path="/dashboard" element={<Customers />} />
              <Route path="/t-documents" element={<Products />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
